'use strict';

app.directive('rmAsideToggle', function ($document) {
  return function (scope, element) {
    var isOpen = false;
    var toggler = angular.element('<a class="aside-toggle icon icon-toggle"></a>');
    var toggle = function () {
      isOpen = !isOpen;
      toggler.toggleClass('icon-toggle', !isOpen);
      toggler.toggleClass('icon-close', isOpen);
      element.toggleClass('open', isOpen);
    };
    var hide = function () {
      isOpen = true;
      toggle();
    };
    element.prepend(toggler);
    toggler.on('click', toggle);
    scope.$on('$locationChangeSuccess', hide);
    var docClick = function (event) {
      if (element[0].contains(event.target)) { return; }
      hide();
    };
    $document.on('click', docClick);
    scope.$on('$destroy', function () {
      $document.off('click', docClick);
    });
  };
});
